/**
 * A global namespace for `reset` event.
 */
const resetEvent = "reset";
export default resetEvent;
